export const AWS_BUG_FIX = "aws_bug_fix";
export const VIEW_TYPE = {
  DATE: "DATE",
  USER: "USER",
  TING: "TING",
  TEAM: "TEAM",
  SEARCH: "SEARCH",
  ORPHANS: "ORPHANS"
};
